import { getApps, initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyA3yYTABYTeNKb9PB83dwjXiTgpL2QCv5E',
  authDomain: 'crm-call-state.firebaseapp.com',
  databaseURL: 'https://crm-call-state-default-rtdb.firebaseio.com',
  projectId: 'crm-call-state',
  storageBucket: 'crm-call-state.firebasestorage.app',
  messagingSenderId: '935606944161',
  appId: '1:935606944161:web:65049552f4c2a270168be0',
};

export const firebaseApp = getApps()[0] ?? initializeApp(firebaseConfig);
export const firebaseDatabase = getDatabase(firebaseApp);
